import { render } from "./readBydywInfo.vue?vue&type=template&id=28e1f9dc&scoped=true"
import script from "./readBydywInfo.vue?vue&type=script&lang=js"
export * from "./readBydywInfo.vue?vue&type=script&lang=js"

import "./readBydywInfo.vue?vue&type=style&index=0&id=28e1f9dc&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e1f9dc"]])

export default __exports__